import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { api, isLoggedIn } from '../api';
import { loginUrl } from '../authNext';

const Star = ({ on, size = 18 }) => (
  <svg viewBox='0 0 24 24' width={size} height={size} aria-hidden='true' className={on ? 'cm-star on' : 'cm-star'}>
    <path d='M12 2.8l2.8 5.7 6.3.9-4.6 4.4 1.1 6.2L12 17l-5.6 3 1.1-6.2L2.9 9.4l6.3-.9z' fill='currentColor' />
  </svg>
);
const LABELS = ['', 'Yomon', "Qoniqarsiz", "O'rtacha", 'Yaxshi', "A'lo"];
const initials = (n) => (n || '?').split(' ').filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
const when = (iso, t) => {
  if (!iso) return '';
  const d = new Date(iso); if (isNaN(d)) return '';
  const days = Math.floor((Date.now() - d) / 86400000);
  return days < 1 ? t('bugun') : days < 30 ? t('{{n}} kun oldin', { n: days }) : d.toLocaleDateString('ru-RU');
};

// Platforma haqidagi haqiqiy sharhlar (avval bu yerda o'zgarmas namunaviy matn bor edi)
export default function Comments() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [text, setText] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => api.getSiteReviews(12).then(r => setData(r && Array.isArray(r.items) ? r : { items: [], count: 0, average: 0, mine: null }));
  useEffect(() => { load(); }, []);

  const start = () => {
    if (!isLoggedIn()) { navigate(loginUrl(window.location.pathname + window.location.search)); return; }
    setRating(data?.mine?.rating || 0); setText(data?.mine?.text || ''); setErr(''); setOpen(true);
  };
  useEffect(() => {
    if (!open) return;
    const esc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', esc); return () => document.removeEventListener('keydown', esc);
  }, [open]);

  const save = async () => {
    if (!rating) { setErr(t('Yulduzchalardan birini tanlang')); return; }
    if (text.trim().length < 10) { setErr(t("Sharh kamida 10 ta belgidan iborat bo'lsin")); return; }
    setSaving(true); setErr('');
    const r = await api.saveSiteReview({ rating, text: text.trim() });
    setSaving(false);
    if (r && r.id) { setOpen(false); load(); } else setErr(r?.message || t("Saqlab bo'lmadi, qayta urinib ko'ring"));
  };

  const items = data?.items || [];
  const shown = hover || rating;
  return (
    <section className='comments'>
      <div className='comment_box'>
        <div className='comment_header'>
          <div>
            <h1>{t("all_comments")}</h1>
            <p>{t("comment_put")}.</p>
            {data && data.count > 0 && (
              <div className='cm-summary'>
                <b>{data.average.toFixed(1)}</b>
                <span className='cm-stars'>{[1, 2, 3, 4, 5].map(i => <Star key={i} on={i <= Math.round(data.average)} />)}</span>
                <span>{t('{{n}} ta sharh', { n: data.count })}</span>
              </div>
            )}
          </div>
          <div><button type='button' onClick={start}>{data?.mine ? t('Sharhimni tahrirlash') : t('Sharh qoldirish')}</button></div>
        </div>

        {data === null ? <p className='cm-empty'>{t('Yuklanmoqda...')}</p>
          : items.length === 0 ? (
            <div className='cm-empty'>
              <p>{t("Hali sharh yo'q. Birinchi bo'lib fikringizni qoldiring!")}</p>
              <button type='button' className='pf-btn' onClick={start}>{t('Sharh qoldirish')}</button>
            </div>
          ) : (
            <div className='comment_row'>
              <div className='comment_col'>
                {items.map(r => (
                  <article className='comment_card' key={r.id}>
                    <div className='cm-top'>
                      <span className='cm-ava' aria-hidden='true'>{initials(r.name)}</span>
                      <div><h1>{r.name}</h1><span>{when(r.createdAt, t)}</span></div>
                    </div>
                    <span className='cm-stars' aria-label={`${r.rating} / 5`}>{[1, 2, 3, 4, 5].map(i => <Star key={i} on={i <= r.rating} size={16} />)}</span>
                    <p>{r.text}</p>
                  </article>
                ))}
              </div>
            </div>
          )}
      </div>

      {open && (
        <div className='pf-modal' onMouseDown={e => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div className='pf-modal-box cm-modal' role='dialog' aria-modal='true' aria-labelledby='cm-title'>
            <div className='pf-modal-head'>
              <h2 id='cm-title'>{data?.mine ? t('Sharhni tahrirlash') : t('Sharh qoldirish')}</h2>
              <button type='button' onClick={() => setOpen(false)} aria-label={t('Yopish')}>×</button>
            </div>
            <p className='cm-hint'>{t('Ijarachi sizga qanchalik yoqdi?')}</p>
            <div className='cm-pick' role='radiogroup' aria-label={t('Baho')} onMouseLeave={() => setHover(0)}>
              {[1, 2, 3, 4, 5].map(i => (
                <button key={i} type='button' role='radio' aria-checked={rating === i} aria-label={`${i} — ${t(LABELS[i])}`}
                  onMouseEnter={() => setHover(i)} onClick={() => { setRating(i); setErr(''); }}>
                  <Star on={i <= shown} size={34} />
                </button>
              ))}
              <span className='cm-label'>{shown ? t(LABELS[shown]) : ''}</span>
            </div>
            <label className='cm-field'>
              <span>{t('Fikringiz')}</span>
              <textarea value={text} maxLength={600} onChange={e => { setText(e.target.value); setErr(''); }}
                placeholder={t("Nima yoqdi, nimani yaxshilash kerak? Masalan: tez uy topdim, egasi bilan bog'lanish qulay...")} />
              <small>{text.trim().length} / 600</small>
            </label>
            {err && <p className='pf-err' role='alert'>{err}</p>}
            <div className='pf-modal-foot'>
              <button type='button' className='pf-btn-ghost' onClick={() => setOpen(false)}>{t('Bekor qilish')}</button>
              <button type='button' className='pf-btn' onClick={save} disabled={saving}>{saving ? t('Saqlanmoqda...') : t('Saqlash')}</button>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}
